__turbopack_context__.v({
  "control": "ColorField-module__bRAdIW__control",
  "disabled": "ColorField-module__bRAdIW__disabled",
  "error": "ColorField-module__bRAdIW__error",
  "helper": "ColorField-module__bRAdIW__helper",
  "hex": "ColorField-module__bRAdIW__hex",
  "invalid": "ColorField-module__bRAdIW__invalid",
  "label": "ColorField-module__bRAdIW__label",
  "root": "ColorField-module__bRAdIW__root",
  "swatch": "ColorField-module__bRAdIW__swatch",
  "swatchEmpty": "ColorField-module__bRAdIW__swatchEmpty",
  "swatchWrapper": "ColorField-module__bRAdIW__swatchWrapper",
});
